 <template>
  <div class="Vow">
    <div class="vowTop">
      <!-- <div class="vowRule">
        <img
          v-if="isreturn==false"
          @click="showRule(true)"
          class="ruleBtn"
          src="../../static/images/activity_rule.png"
          alt
        />
        <img
          v-if="isreturn==false"
          @click="jumpRewardList"
          class="ruleBtn2"
          src="../../static/images/activity_reward.png"
          alt
        />
      </div>-->
      <!-- <div class="vowRule-height"></div> -->
      <RuleBtn v-bind:fromType="0" v-bind:myuser="myuser" v-on:showPhone="showPhone"></RuleBtn>
      <div class="vowRefresh">
        <div class="text-center">
          <!-- 点击星星可查看别人的愿望 -->
          <p class="topTotal">
            已有
            <span class="wish-num">{{wishTotal}}人</span>许下星愿
          </p>
          <p class="topLookVow2">点击查看</p>
          <img class="wish-allow" src="../../static/images/wish_allow.png" alt />
        </div>
        <div @click="getWishByRand" class="topBtnImg vow-btn2"></div>
      </div>
      <div v-show="modalStatu!='show'" class="vowBtnView">
        <!-- 空格符占位，防止无文字，样式上移 -->
        <p class="vowText">{{isreturn==false && isover==false?"欠自己的旅行是不是该还了？":"&nbsp;"}}</p>
        <img
          v-if="isover==false && objVow.iswish==0"
          @click="toVow"
          class="vowBtn"
          src="../../static/images/vow_btn.png"
          alt
        />
        <img
          v-if="isover==true"
          @click="toVow"
          class="vowBtn"
          src="../../static/images/activity_over.png"
          alt
        />
        <img
          v-if="objVow.iswish==1 && isover==false"
          @click="toReward"
          class="vowBtn"
          src="../../static/images/go_reward.png"
          alt
        />
      </div>
      <div class="logo-wrap flex-row">
        <img class="logo" src="../../static/images/logo.png" alt />
        <template v-if="_getAPPParams().channel == 'by0110'">
          <img class="logo-and" src="../../static/images/icon_and.png" alt />
          <img class="logo" src="../../static/images/logo2.png" alt />
        </template>
        <!-- <template v-if="_getAPPParams().channel == 'fd0110'">
          <img class="logo-and" src="../../static/images/icon_and.png" alt />
          <img class="logo" src="../../static/images/logo2.png" alt />
        </template>
        <template v-if="_getAPPParams().channel == 'mzgy0110'">
          <img class="logo-and" src="../../static/images/icon_and.png" alt />
          <img class="logo" src="../../static/images/logo2.png" alt />
        </template>-->
      </div>
    </div>
    <Reward v-bind:mypoint="'homepage#adclick'" v-if="isreturn==false"></Reward>
    <RulePopup @closeRule="showRule" :show="isshowrule" :ruleText="activityInfo.rule_desc"></RulePopup>
    <Phone
      v-if="isphone && myuser && myuser.isbindtel == 0"
      v-on:closePhone="closePhone"
      v-on:changeBind="changeBind"
    ></Phone>
    <!-- 抽奖机会用完弹窗 -->
    <div v-if="isCountUpper" class="help-alert-wrap flex-column">
      <div class="help-alert fail flex-column">
        <div class="help-alert-title">抽奖机会</div>
        <div class="help-alert-name">抽奖机会已用完</div>
        <div class="help-alert-desc02">快去收集好友祝福吧</div>
        <div @click="closeWin" class="common-bg help-alert-btn">获得更多抽奖机会</div>
      </div>
      <img @click="closeWin" class="alert-close" src="../../static/images/alert_close.png" alt />
    </div>
    <!-- 查看他人愿望弹窗 -->
    <div class="help-alert-wrap flex-column" v-if="modalStatu=='show'">
      <div class="help-alert fail flex-column vowbg">
        <div class="help-alert-title">{{objVow.vowTitle}}</div>
        <div class="vowText2">{{objVow.vowText}}</div>
      </div>
      <p class="helpText">已收集到{{objVow.vowHelpNum}}人助力</p>
      <img
        @click="commHideModal('hide')"
        class="alert-close"
        src="../../static/images/alert_close.png"
        alt
      />
      <div @click="toVow" v-if="objVow.iswish==0" class="vowBtn4"></div>
    </div>
    <input type="hidden" id="hello" value style="display:none;" />
    <div
      v-if="_getBrowser()==0"
      class="copy-btn btn-clipboard"
      id="btnH5"
      @click="_downloadAPP(2,'wish#pop_getsuccess_appdownload')"
      style="height:100vh;width:100vw;position:fixed;left:0;top:0;opacity:0;z-index:1000"
      data-clipboard-target="#hello"
    >下载app</div>
    <div
      v-else
      class="copy-btn"
      @click="toVow"
      style="height:100vh;width:100vw;position:fixed;left:0;top:0;opacity:0;z-index:1000"
    >下载app</div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Swipe, SwipeItem, Lazyload, Picker, Toast, Field } from "vant";
import CanvasPoster from "vue-canvas-poster";
import Reward from "../components/Reward.vue";
import RulePopup from "../components/RulePopup.vue";
import RuleBtn from "../components/RuleBtn.vue";
import Phone from "../components/Phone.vue";
Vue.use(CanvasPoster);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Button).use(Lazyload);
Vue.use(Picker)
  .use(Reward)
  .use(Toast)
  .use(Field)
  .use(RulePopup);

export default {
  name: "Vow",
  components: { Reward, RulePopup, Phone,RuleBtn },
  data() {
    return {
      total: 10220,
      isbindtel: 0,
      myuser: null,
      isshowrule: false,
      ruleText: "",
      info: "",
      isphone: false,
      isCountUpper: false,
      modalStatu: "hide",
      objVow: {
        vowTitle: "旅游愿望",
        vowText: "",
        vowHelpNum: 0, //随机愿望助力人数
        iswish: 0 //当前用户是否许愿  0 否 1 是
      },
      isreturn: this.$route.query.isreturn ? true : false, //是否 返回按钮跳转
      isover: false
    };
  },
  methods: {
    //获得活动信息
    // getActivityInfo() {
    //   var t = this;
    //   t._getActivityInfo()
    //     .then(res => {
    //       t.info = res;
    //       this.ruleText = t.info.rule_desc;
    //     })
    //     .catch(error => {
    //       console.log("_getActivityInfo error", error);
    //     })
    //     .finally(() => {
    //       console.log("finally");
    //     });
    // },

    changeBind(isbindtel) {
      var t = this;
      // console.log('isbindtel')
      // console.log(isbindtel)
      t.myuser.isbindtel = 1;
    },

    closePhone() {
      this.isphone = !this.isphone;
      if (this.modalStatu == "shouldHide") this.modalStatu = "show";
    },

    showPhone(){
      this.isphone = true;
    },

    // 是否绑定手机号
    getMyUserInfo() {
      var t = this;
      t._getUser(function(err, myuser) {
        if (!err) {
          t.myuser = myuser;
          console.warn(myuser);
        }
      });
    },
    //随机获取某人愿望
    getWishByRand() {
      var t = this;
      var params = {};
      console.log(params);
      t._get("user", "User.getWishByRand", params)
        .then(res => {
          if (res.status == 0) {
            let user = t.getBaseUser();
            if (user.iswish == 1) t.objVow.iswish = 1;
            t.commHideModal("show");
            this.objVow.vowHelpNum = res.data.wish_user.help_num;
            this.objVow.vowText = res.data.wish_user.wish_str;
          } else {
            // typeof callback == "function" && callback(error);
            t.$toast(res.msg);
          }
        })
        .catch(error => {
          // typeof callback == "function" && callback(error);
          console.log(`error:${error}`);
          t.$toast("请求错误");
        });
      var mypoint = "homepage1#TAwish";
      if (t.isreturn == false) {
        mypoint = "sharepg#TAwish";
      }
      t._deepmain(t.pageId, mypoint, 2);
    },

    // 去许愿
    async toVow() {
      var t = this;
      t.$router.push({
        path: "/"
      });
      return;
      var mypoint = "homepage1#makewish";
      if (t.isreturn == false) {
        mypoint = "sharepg#wishpool_makewish";
      }
      t._deepmain(t.pageId, mypoint, 2);
      //用户已许愿

      let b = await this.getBaseUser(); //是否已经许愿
      if (b.iswish == 1) {
        t.modalStatu = "show";
        return;
      }
      if (t.modalStatu == "show") t.modalStatu = "shouldHide";
      if (t.myuser.isbindtel == 0) {
        t.isphone = true;
        return false;
      }
      t.$router.push({
        path: "/newvow",
        query: {}
      });
    },
    // 去活动规则页面
    toActive() {
      var t = this;
      // if (t.configInfo && t.configInfo.isRulePage == 0) {
      //   t.scrollBottom();
      // } else {
      //   t.$router.push({
      //     path: "/active",
      //     query: {}
      //   });
      // }
    },
    //规则弹窗
    showRule(statu) {
      this._deepmain(this.pageId, "homepage1#rules", 2);
      this.isshowrule = statu;
    },
    //跳转奖励列表
    jumpRewardList() {
      this._deepmain(this.pageId, "homepage1#award", 2);
      if (this.myuser.isbindtel == 0) {
        //奖励列表 必须绑定手机号。
        this.isphone = true;
        return;
      }
      this.$router.push({
        path: "/team",
        query: {}
      });
    },
    //去抽奖
    toReward() {
      this.$router.push({
        path: "/vowdraw",
        query: {}
      });
    },
    //查看愿望弹窗
    commHideModal(status) {
      this.modalStatu = status;
    },
    async getBaseUser() {
      var _this = this;
      let obj = {};
      var params = {
        rec_uid: _this._getAPPParams().share_userid,
        activity_id: _this._getAPPParams().activity_id
      };
      await _this._signup("user", "User.getUserInfo", params).then(res => {
        if (res.status == 0) {
          obj = res.data.user;
        }
      });
      return obj;
    },
    changeReturn(status) {
      this.isreturn = status;
    },
    async getActivity() {
      let obj = {};
      await this._getActivityInfo().then(res => {
        obj = res;
      });
      return obj;
    },
    async init() {
      let a = await this.getActivity(); //活动是否过期
      //   let b = await this.getBaseUser(); //是否已经许愿
      //   this.isover = a.isover;
      //   this.objVow.iswish = b.iswish;
      //   if (b.iswish == 1 && this.isreturn == false) {
      //     //许愿自动跳转
      //     this.$router.push({
      //       path: "/vowdraw",
      //       query: {}
      //     });
      //   }
    }
  },
  mounted() {
    this.init();
    // this.getMyUserInfo();
    this._deepmain(this.pageId, "homepage1#allwish_access#else", 0);
  }
};
</script>

<style scoped lang="scss" src="../../static/scss/vow.scss"></style>
